import { ContactForm } from '@/components/ContactForm.tsx';
import { Layout } from '@/components/Layout.tsx';
import { ROLE_OPTIONS } from '@/data/content.ts';
import { WEBHOOKS } from '@/data/site.ts';

export function Contact() {
  return (
    <Layout currentPath="/contact" navOnLight={true}>
      <section className="contact-page-section">
        <div className="container contact-page__grid">
          {/* Left Column: Heading, Info, Email */}
          <div className="contact-page__info fade-in">
            <h1>
              Let&apos;s talk about
              <br />
              your school
            </h1>
            <p className="contact-page__lede">
              Whether you&apos;re a teacher curious about AI tutoring, an
              administrator exploring options, or a district leader planning
              ahead &mdash; we&apos;d love to hear from you.
            </p>
            <div className="contact-page__email-box">
              <p>
                Or email us directly at{' '}
                <a
                  href="mailto:hello@learnpsl.ai"
                  className="contact-page__email-link"
                >
                  hello@learnpsl.ai
                </a>
              </p>
            </div>
          </div>

          {/* Right Column: Contact Form Card */}
          <div className="contact-page__card fade-in">
            <ContactForm
              action={WEBHOOKS.contact}
              submitLabel="Send Message"
              showArrow={false}
              buttonClassName="btn contact-page__submit"
              successTitle="Message Sent"
              successBody="Thanks for reaching out — our team will be in touch shortly."
              fields={[
                {
                  name: 'name',
                  label: 'Name',
                  type: 'text',
                  placeholder: 'Jane Doe',
                  required: true,
                },
                {
                  name: 'email',
                  label: 'Email',
                  type: 'email',
                  placeholder: 'jane@school.edu',
                  required: true,
                },
                {
                  name: 'role',
                  label: 'Role',
                  type: 'select',
                  placeholder: 'Select your role',
                  options: ROLE_OPTIONS,
                  required: true,
                },
                {
                  name: 'organization',
                  label: 'School / District Name',
                  type: 'text',
                  placeholder: 'Lincoln High School',
                  required: true,
                },
                {
                  name: 'message',
                  label: 'Message',
                  type: 'textarea',
                  placeholder: 'How can we help?',
                  required: true,
                },
              ]}
            />
          </div>
        </div>
      </section>
    </Layout>
  );
}
